<template>
  <div class="billType">
    <h4 class="billType-title"> {{type == 1?'正面清单':'负面清单'}} </h4>
    <div class="billType-box">
      <el-table :data="type == 1?tableData2:tableData" border style="width: 100%">
        <el-table-column width="80" label="#" type="index"> </el-table-column>
        <el-table-column prop="name" width="200" label="项目">
        </el-table-column>
        <el-table-column prop="describe" label="描述">
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tableData: [
        {
          name: "疑难复杂或病情不稳定",
          describe:
            "服务对象病情疑难复杂或病情不稳定，上门提供护病情不稳定 理服务存在医疗安全风险的。",
        },
        {
          name: "用药管理",
          describe:
            "涉及含有麻醉药品、精神药品、医用毒性药品、放射性药品等特殊管理药品的。",
        },
        {
          name: "护理操作",
          describe:
            "需提供输液等创伤性且医疗安全风险大，或对操作环境有特殊要求的护理项目的。",
        },
        {
          name: "引流管冲洗",
          describe:
            "在服务过程中，发现引流管堵塞，擅自为服务对象进行床旁冲洗（导尿管、鼻胃管除外）。",
        },
        {
          name: "医学美容治疗",
          describe:
            "为服务对象提供祛斑美肤、嫩肤美白、除皱紧肤、艺术纹绣等医学美容项目的。",
        },
      ],
      tableData2: [
        {
          name: "生活自理能力训练",
          describe:
            "根据患者病情、生活自理能力，指导、训练患者或其照顾者选择适宜的进食方法、个人卫生、穿脱衣裤鞋袜、床椅转移等日常生活自理方法，提高自理能力和生活质量。为关节活动障碍的患者进行被动运动，促进肢体功能的恢复。",
        },
        {
          name: "居家安全护理",
          describe:
            "根据患者的病情、意识、活动能力、生理机能、家庭环境等，做好坠床、跌倒、烫伤、误吸、误食、错服药物等意外的防护。同时对患者或其照顾者进行安全方面的指导。必要时指导患者或其照顾者选择合适的安全保护用具，安全保护用具包括保护手套、保护带（腕带、腰带）、保护床栏、护理垫、保护座椅、保护衣等。",
        },
        {
          name: "压疮预防护理",
          describe:
            "根据患者的病情，对易发生压疮的患者采取定时翻身、气垫减压等方法预防压疮的发生。为患者及照顾者提供压疮预防护理的健康指导。",
        },
        {
          name: "坠积性肺炎预防护理",
          describe:
            "根据患者的病情、有无手术、引流管、骨折和牵引等，对患者卧位、翻身、拍背等进行指导，选择合适的翻身频次、体位、方式帮助患者翻身拍背，促进排痰。对患者及照顾者进行坠积性肺炎预防健康教育。",
        },
        {
          name: "母婴护理",
          describe:
            "根据护理对象个体情况，提供母乳喂养、产褥期常见疾病护理及心理、健康、饮食、运动指导，提供新生儿护理要点指导。如生乳指导、婴儿母乳喂养指导、新生儿抚触、会阴伤口护理、脐部护理、红臀护理、婴儿服饰添加指导、新生儿沐浴等项目。",
        },
        {
          name: "生命体征监测",
          describe:
            "为患者进行体温、脉搏、呼吸、血压、血氧饱和度等方面的监测。",
        },
        {
          name: "氧气吸入",
          describe: "遵医嘱给予患者氧气吸入，给予居家用氧知识指导。",
        },
        {
          name: "物理降温",
          describe:
            "为高热患者使用酒精或温水进行擦浴降温或使用冰袋、冰囊或降温贴等降温，并给予高热相关护理知识的指导。",
        },
        {
          name: "鼻饲",
          describe: "遵医嘱经鼻胃管/鼻肠管给予胃肠营养、水和药物。",
        },
        {
          name: "血糖监测",
          describe:
            "对患者手指、耳垂实施采血，用床旁血糖仪测得数值。将结果告知患者/照顾者，做好记录。做好相关饮食及康复指导。",
        },
        {
          name: "静脉采血",
          describe: "遵医嘱为患者经静脉抽取血液标本。",
        },
        {
          name: "肌肉注射",
          describe: "遵医嘱将药物注入患者的肌肉组织内，并实施用药指导。",
        },
        {
          name: "皮下注射",
          describe: "遵医嘱将药物注入患者的皮下组织，并实施用药指导。",
        },
        {
          name: "外周静脉留置针的维护",
          describe:
            "经过评估，选择生理盐水或合适的肝素溶液对外周静脉留置针进行冲管和封管，以保持导管通畅。并根据情况对敷料进行更换。告知患者和照顾者注意事项，并进行安全指导。",
        },
        {
          name: "留置/更换导尿管的护理",
          describe:
            "遵医嘱对留置尿管的患者做好会阴护理，保持尿道口清洁，保持尿管通畅。定期更换尿管及尿袋。留置尿管期间，妥善固定尿管及尿袋，拔管后根据病情，鼓励患者多饮水，观察患者自主排尿及尿液情况，有排尿困难及时处理。",
        },
        {
          name: "一般灌肠",
          describe:
            "遵医嘱将灌肠液经肛门灌入肠道，软化粪块、刺激肠蠕动、促进排便、解除便秘、清洁肠道，并给予相关知识指导。",
        },
        {
          name: "直肠栓剂给药",
          describe: "遵医嘱为患者经肛门使用开塞露、直肠栓剂，观察用药反应。",
        },
        {
          name: "更换引流袋",
          describe:
            "留置引流管期间，定期更换引流袋，妥善固定、放置引流袋，保持有效引流，保持引流管周围皮肤的干燥清洁。对患者和家属进行安全及健康教育指导，观察引流液的颜色、性状和量，发现异常及时与就诊。",
        },
        {
          name: "普通伤口护理",
          describe: "遵医嘱对患者的普通伤口进行换药，并给予相关指导。",
        },
        {
          name: "经外周静脉置入中心静脉导管（PICC）的维护",
          describe:
            "为留置经外周静脉置入中心静脉导管（PICC）的患者，进行患者情况评估包括局部评估（感染、渗液等）和全身评估（发热、肢体肿胀麻木等）、导管的功能评估（包括通畅性、完整性、外置长度、留置长度等），进行皮肤消毒、导管的冲封管、敷料和接头更换及导管的正确固定，并对患者及照顾者进行日常管理维护指导。",
        },
        {
          name: "植入式输液港（PORT）的维护",
          describe:
            "为留置植入式静脉输液港（PORT）的患者进行全身情况评估及患者局部、导管的功能评估，进行皮肤消毒、无损伤针穿刺行导管冲封管，对患者及照顾者进行日常管理维护指导。",
        },
        {
          name: "造口护理",
          describe:
            "遵医嘱为直肠、结肠或回肠肛门改道造瘘术后患者提供造口护理，更换造口袋，对患者及照顾者进行日常清洁与维护指导。",
        },
        {
          name: "压疮伤口换药",
          describe:
            "对压疮伤口进行评估，根据压疮分级，选择适宜的药物和合适的敷料，进行压疮伤口换药。",
        },
        {
          name: "失禁性皮炎的预防及护理",
          describe:
            "对失禁性皮炎进行评估，选择合适的方法、药物、敷料、护理用品进行处理，并对患者及照顾者进行健康指导。",
        },
        {
          name: "气管切开置管的护理",
          describe:
            "对患者进行评估，清洗气管切开套管并进行分泌物清理、更换切开部位敷料，以保持管道通畅和切开部位的清洁干燥。对患者和家属进行安全及健康教育指导。",
        },
        {
          name: "糖尿病足的护理",
          describe:
            "对患者溃疡部位进行评估，选择合适的敷料及药物进行处理，并对患者及照顾者进行健康教育指导。",
        },
        {
          name: "慢阻肺居家康复",
          describe:
            "对慢阻肺患者进行评估，制订肺康复方案，通过每月至少两次的随访和动态实时监测促进患者运动、呼吸锻炼、用药、氧疗、无创呼吸治疗等，实现患者的长期照护与居家康复。",
        },
        {
          name: "安宁居家照护",
          describe:
            "对疾病终末期病人进行评估，制定安宁居家照护计划，协助家属进行舒适照护、疼痛管理、症状评估及指导、心理支持、灵性照护和哀伤辅导，对患者及照顾者开展死亡教育和健康知识宣教。",
        },
        {
          name: "淋巴水肿护理",
          describe:
            "对淋巴水肿患者，特别是肿瘤综合治疗后继发性淋巴水肿患者实行手法引流综合消肿治疗(CDT 治疗)，包括手法淋巴引流、弹性压力包扎、皮肤护理及功能锻炼，以及系统治疗后巩固治疗阶段的压力制品效果评估、健康教育指导等。",
        },
      ],
      type: this.$route.query.type,
    };
  },
  mounted() {
  },
  methods: {},
  components: {},
};
</script>

<style lang="scss" scoped>
.billType{
    height: 100%;
}
.billType-title {
  text-align: center;
  padding-top: 50px;
  font-size: 26px;
}
.billType-box {
  width: 80%;
  margin: auto;
  margin-top: 20px;
    padding-bottom: 100px;
}
</style>
<style>
html,
body,
#app{
    height: 100%;
    background: #f3fafb;
}
</style>



// WEBPACK FOOTER //
// src/pages/component/billType.vue